import React, { useState, useEffect } from 'react';
import { get } from '../../utils/apiUtils';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPeopleGroup, faBell, faRobot, faPlug, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faCircleDown } from '@fortawesome/free-regular-svg-icons';
import DataTableBase from '../helpers/DataTable';
import {
  Input,
  SectionTitle,
  SubSectionTitle,
  ButtonSuccess,
  Button,
  FormGroup,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  FormRow,
  Label,
  FormRowFull,
  Toggle,
  ToggleInput,
  Divider,
  fadeIn
} from '../../styles/PageStyles';



const GroupDetails = ({ group, onSelectUser, onSaveGroup }) => {
  const { user, setUser } = useAuth();
  const [groupDetails, setGroupDetails] = useState(group || { name: '', company_cd: user.companyCd, status: "INACTIVE" });
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {
    if (group) {
      setGroupDetails(group);
    }
  }, [group]);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await get(`/api/v1/mms_authentication/users/group/${group.name}`);
        setUsers(response);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (group) {
      fetchUsers();
    }
  }, [group, user]);
  // Get user initials for avatar
  const getUserInitials = (user) => {
    if (!user || !user.first_name) return 'U';
    return [user.first_name, user.last_name].map(n => n[0]).join('').toUpperCase();
  };

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'active';
      case 'connected': return 'active';
      case 'archived': return 'default';
      case 'disconnected': return 'error';
      default: return 'default';
    }
  };
  const getGender = (status) => {
    switch (status) {
      case 'M': return 'Male';
      case 'F': return 'Female';
      case 'Other': return 'Other';
      default: return 'default';
    }
  };
  const filteredUsers = users.filter((user) => {
    return user?.first_name?.toLowerCase().includes(searchTerm?.toLowerCase())
    // return user
  });

  return (
    <div>
      <SectionTitle>
      {groupDetails ? (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Edit {groupDetails.name} 
          </span>
        ) : (
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Add Group
          </span>
        )}
      </SectionTitle>
      <Divider />
      <FormRow>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" value={groupDetails?.name || ''}
            onChange={(e) => setGroupDetails({ ...groupDetails, name: e.target.value })}
          />

        </FormGroup>
        <FormGroup>
          <Label>Company</Label>
          <Input type="text" disabled value={groupDetails?.company_cd || ''}
            onChange={(e) => setGroupDetails({ ...groupDetails, company_cd: e.target.value })} />
        </FormGroup>
      </FormRow>
      <FormRowFull>
        <FormGroup>
          <Label>Description</Label>
          <Input type="text" value={groupDetails?.description || ''}
            onChange={(e) => setGroupDetails({ ...groupDetails, description: e.target.value })}
          />
        </FormGroup>
      </FormRowFull>
      <FormRow>
        <FormGroup>
          <Label>Status</Label>
          <Toggle>
            <ToggleInput
              type="checkbox"
              checked={groupDetails.status === "ACTIVE"}
              onChange={(e) => {
                setGroupDetails({
                  ...groupDetails,
                  status: e.target.checked ? "ACTIVE" : "INACTIVE",
                });
              }}
            />
          </Toggle>
        </FormGroup>
      </FormRow>
      <form>

        <Button primary type="button" onClick={() => onSaveGroup(groupDetails)}>
          Save
        </Button>
      </form>
      {groupDetails?.id && (
        <>
          <Divider />
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '1rem' }}>
            <SubSectionTitle>Users</SubSectionTitle>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '2px', alignItems: 'center' }}>
              <Input type="text" placeholder="Search Users..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <ButtonSuccess onClick={() => onSelectUser({})}><FontAwesomeIcon icon={faPlus} /> User</ButtonSuccess>
            </div>
          </div>
          <Divider />
          <Table>
            <thead>
              <tr>
                <TableHeader>Name </TableHeader>
                <TableHeader>Gender</TableHeader>
                <TableHeader>Email</TableHeader>
                <TableHeader>Actions</TableHeader>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(user => (
                <TableRow key={user.id}>
                  <TableCell>{user.first_name} {user.last_name}</TableCell>
                  <TableCell>{getGender(user.gender)}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', gap: '0.5rem' }} onClick={() => onSelectUser(user)}>
                      <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>View</Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};

export default GroupDetails;